import axios from 'axios';
import { apiClient } from './apiClient';
import { ApiError } from '../error/error';


export const refreshTokenApiCall = async () => {
  try {
    const response = await apiClient.post(`api/admin/token/refresh`);

    return response;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      // Throw an ApiError with message and status code from response
      throw new ApiError(error.response.data.message ||error.response.data.error || 'Failed to refresh token', error.response.status);
    }
    throw new Error('An unknown error occurred');
  }
};
export const getTokenExpirationApiCall = async () => {
  try {
    const response = await apiClient.get(`api/admin/token/expiration`);

    return response;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      // Throw an ApiError with message and status code from response
      throw new ApiError(error.response.data.message ||error.response.data.error || 'Failed to refresh token', error.response.status);
    }
    throw new Error('An unknown error occurred');
  }
};